import { createFileRoute } from "@tanstack/react-router";

import { BrandLogo } from "@/components/brand/BrandLogo";
import { ForwardedAccess } from "@/components/landing/ReviewAccess";
import { COMPANY, COMPANY_LEGAL_FOOTER } from "@/lib/company";

const TITLE = "View access for Adkiro | Adkiro";

// The page a client forwards to whoever manages the firm's Meta business
// account. That person paid for nothing and may not know Adkiro, so there is
// no price, no payment and no offer here: who is asking, what they will see,
// and the steps. Unlisted: no nav link, noindex, not in the sitemap.
export const Route = createFileRoute("/access")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "robots", content: "noindex, nofollow" },
      {
        name: "description",
        content: "The steps to give Adkiro view access to a Meta ad account.",
      },
    ],
  }),
  component: AccessPage,
});

function AccessPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 border-b border-border bg-background/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center px-5 py-4 lg:px-8">
          <BrandLogo />
        </div>
      </header>

      <main>
        <section className="border-b border-border">
          <div className="mx-auto max-w-3xl px-5 pb-12 pt-14 lg:px-8 lg:pt-20">
            <div className="hero-eyebrow">
              <span className="hero-eyebrow__line" />
              <span>Meta ad account</span>
            </div>
            <h1 className="mt-7 text-[clamp(2.1rem,4.6vw,3.2rem)] leading-[1.04]">
              Give Adkiro view access to your ad account
            </h1>
            <p className="mt-6 text-lg leading-relaxed text-muted-foreground">
              Someone at your firm asked Adkiro to review its Meta ad account. For that, Adkiro
              needs to see the ads and their results, and nothing more. It takes a few minutes on a
              computer and must be done by an admin of the firm's Meta business account.
            </p>
          </div>
        </section>

        <section className="mx-auto grid max-w-4xl gap-8 px-5 py-14 lg:px-8">
          <ForwardedAccess />
        </section>
      </main>

      <footer className="border-t border-border py-8">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 text-sm text-muted-foreground sm:flex-row lg:px-8">
          <BrandLogo compact />
          <span className="text-center sm:text-right">
            © {new Date().getFullYear()} Adkiro · {COMPANY_LEGAL_FOOTER}, Sofia ·{" "}
            <a href={`mailto:${COMPANY.email}`} className="hover:text-foreground">
              {COMPANY.email}
            </a>{" "}
            ·{" "}
            <a href="/privacy" className="hover:text-foreground">
              Privacy
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}
